// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"uh","summaryPar":"vh","ratingCategories":"wh","reviewerInfo":"xh","reviewTypes":"yh","expanded":"zh"};